import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetMainArticlesActionType {
  Reset = 'mainArticles/resetMainArticles',
}

export type TResetMainArticles = ITypedReduxAction<EResetMainArticlesActionType.Reset>;
